<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Canteen Menu</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Menu Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="canteen_menu_type"
              :items="canteen_menu_type_list" item-text="name" item-value="id" label="Menu Type" outlined />
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Menu Category</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="canteen_menu_category"
              :items="canteen_menu_category_list" item-text="name" item-value="id" label="Menu Category" outlined />
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Name</b></p>
            <v-text-field outlined dense type="text" v-model="name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Rate</b></p>
            <v-text-field outlined dense type="number" v-model="rate"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="name && rate && canteen_menu_category && canteen_menu_type">
          <v-btn color="warning" @click="saveCanteenMenu()" :loading="loader">Add</v-btn>
        </v-row>
      </v-card>
      <v-card class="box" v-if="canteen_menu_list != ''">
        <v-data-table :headers="headers" :items="canteen_menu_list" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Canteen Menu List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </v-card-title>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="editDetail(item)">mdi-pencil</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch color="brand" v-model="item.isactive" @change="toggleIsactive(item)"></v-switch>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deleteCanteenMenu(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Canteen Menu Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Menu Id</b></p>
                <v-text-field outlined dense type="number" v-model="editedItem.menuid"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Name</b></p>
                <v-text-field outlined dense type="text" v-model="editedItem.name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Rate</b></p>
                <v-text-field outlined dense type="number" v-model="editedItem.rate"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Menu Type</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.canteenmenutype"
                  :items="canteen_menu_type_list" item-text="name" item-value="id" label="Menu Type" outlined />
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Menu Category</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.canteenmenucategory"
                  :items="canteen_menu_category_list" item-text="name" item-value="id" label="Menu Category" outlined />
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditCanteenMenu()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    search:"",
    loader: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    name: "",rate:"",
    canteen_manu_list:[],canteen_menu_type_list:[],canteen_menu_category_list:[],canteen_menu_type:"",canteen_menu_category:"",
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Menu Id", value: "menuid" },
      { text: "Name", value: "name" },
      { text: "Rate", value: "rate" },
      { text: "Manu Type", value: "canteenmenutype" },
      { text: "Manu Category", value: "canteenmenucategory" },
      { text: "Is-active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
   
    dialog_edit: false,
    editedItem: {
      id: "",
      name: "",menuid:"",rate:"",canteenmenutype:"",canteenmenucategory:""
    },
  }),
  methods: {
     deleteCanteenMenu(item) {
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/Canteen/deleteCanteenMenu", data)
        .then((res) => {
          if (res.data.flag == "YES") {
          (this.canteen_menu_list = res.data.canteen_menu_list),
            this.showSnackbar("green", "Deleted Successfully...");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    toggleIsactive(item){
         const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Canteen/toggleIsactiveCanteenMenu", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.canteen_menu_list = res.data.canteen_menu_list),
            this.showSnackbar("green", "Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
   
    saveEditCanteenMenu() {
      this.overlay = true;
      this.loader = true;
      axios
        .post("/Canteen/saveEditCanteenMenu", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
             (this.canteen_menu_list = res.data.canteen_menu_list),
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.menuid = item.menuid;
      this.editedItem.rate = item.rate;
      this.editedItem.name = item.name;
      this.editedItem.canteenmenutype = item.canteenmenutype_id;
      this.editedItem.canteenmenucategory = item.canteenmenucategory_id;
      this.dialog_edit = true;
    },
    saveCanteenMenu() {
      const data = {
        name:this.name,
        rate:this.rate,
        canteen_menu_type:this.canteen_menu_type,
        canteen_menu_category:this.canteen_menu_category,
      };
      this.overlay = true;
      axios
        .post("/Canteen/saveCanteenMenu", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.canteen_menu_list = res.data.canteen_menu_list)
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("Canteen/getCanteenMenuList")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.canteen_menu_list = res.data.canteen_menu_list),
            (this.canteen_menu_category_list = res.data.canteen_menu_category_list),
            (this.canteen_menu_type_list = res.data.canteen_menu_type_list),
              (this.overlay = false);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
/* .box2 {
  overflow-x: hidden;
  width: 98%;
} */
</style>